import { Route } from '@angular/router';
import { TenderListResolver } from '../../resolvers';
import { TendersComponent, TendersListComponent } from '../../../pages';
import { activeTenderListRoute, draftTenderListRoute, pastTenderListRoute } from './children';
import { IsBuyerGuard } from '../../../../auth/routing/guards/is-buyer.guard';

export const tenderListRoute: Route = {
    path: 'tenders',
    component: TendersComponent,
    //canActivate: [IsBuyerGuard],
    children: [
        {
            path: '',
            component: TendersListComponent,
            resolve: {
                tenders: TenderListResolver
            }
        },
        activeTenderListRoute,
        pastTenderListRoute,
        draftTenderListRoute
    ]
};
